import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = [ "template", "insertionPoint", "fieldSet" ]

  connect() {
    this.element[this.identifier] = this
    this.check_remove_button_visibility()
  }

  add_association(event) {
    event.currentTarget.blur()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.insertionPointTarget.insertAdjacentHTML('beforebegin', content)

    const fieldsets = this.fieldSetTargets
    const lastFieldset = fieldsets[fieldsets.length - 1]
    let focusableField = lastFieldset.querySelector("input:not([type='hidden']),select,trix-editor")
    focusableField?.focus()

    this.check_remove_button_visibility()
  }

  remove_association(event) {
    event.preventDefault()

    let wrapper = this.fieldSetTargets.find(target => target.contains(event.target))

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove()

    // Existing records are hidden and flagged for deletion
    } else {
      let destroyField = wrapper.querySelector("input[name*='_destroy']")
      if (destroyField) { destroyField.value = 1 }
      wrapper.classList.add("hidden")
    }

    this.check_remove_button_visibility()
  }

  // Keep a single visible fieldset free of the per-row delete button:
  // with just one row, the "remove all" action at the top of the section
  // already covers deletion, and showing both is confusing.
  check_remove_button_visibility() {
    const visible = this.fieldSetTargets.filter(t => !t.classList.contains("hidden"))
    if (visible.length == 1) {
      visible[0].querySelector('[data-action="nested-form#remove_association"]')?.classList.add("invisible")
    } else {
      this.element.querySelectorAll('[data-action="nested-form#remove_association"]').forEach(button => {
        button.classList.remove("invisible")
      })
    }
  }
}